import { useState } from 'react'
import { Modal, Card, Separator, Typography, theme, Link, Button, Flex, Box } from '@fe-toolkit/web-components/ssr'

import styled from 'styled-components'

import { formatDate } from '@/utils/formatDate/formatDate'
import { OrderDetail } from '@/api'

import CancelOrderModalContent from '../CancelOrderModal/CancelOrderModal'
import InstallationAddressCard from '../InstallationAddressCard/InstallationAddressCard'

export type OrderDetailsProps = {
  orderData: OrderDetail | undefined
  handleChatRequest: () => void
}

const OrderDetailsCard = ({ orderData, handleChatRequest }: OrderDetailsProps) => {
  const [showModal, setShowModal] = useState(false)
  const showCancelOrderButton: boolean = !!orderData && orderData.cancellable

  return (
    <Card backgroundColor="transparent">
      <Typography as="h3" variant="whisper">
        Order placed
      </Typography>
      <Typography as="p" marginBottom={theme.spacing.small} variant="speak">
        {formatDate(orderData?.orderDate, { year: 'short' })}
      </Typography>

      <Separator colour="gallery" marginBottom={theme.spacing.small} marginTop={theme.spacing.small} />

      <Typography as="h3" variant="whisper">
        Order number
      </Typography>
      <Typography data-di-mask as="p" marginBottom={theme.spacing.small} variant="speak">
        {orderData?.key}
      </Typography>

      <Separator colour="gallery" marginBottom={theme.spacing.small} marginTop={theme.spacing.small} />

      {/* Installation address */}
      <InstallationAddressCard premise={orderData?.premise} />

      {/* TODO: do we need cancellation info to be updated when designs are available. */}
      <Box marginBottom={theme.spacing.small}>
        <Typography as="p" marginBottom={theme.spacing.small} variant="speak">
          {orderData?.stateDescription}
        </Typography>
        {orderData?.cancellationCompletionDate && (
          <Typography as="h4" marginBottom={theme.spacing.tiny} variant="whisper">
            Order cancelled on {formatDate(orderData?.cancellationCompletionDate, { year: 'short' })}
          </Typography>
        )}
      </Box>

      {showCancelOrderButton && (
        <>
          <Separator colour="gallery" marginBottom={theme.spacing.tiny} marginTop={theme.spacing.small} />
          <Link chevron fullWidth onClick={() => setShowModal(true)}>
            Cancel Order
          </Link>
        </>
      )}

      <Modal
        backdrop
        closeModal={() => setShowModal(false)}
        display={showModal}
        modalBackgroundColour={'wildSand'}
        setDisplay={setShowModal}
        title="Order details"
      >
        <CancelOrderModalContent />
        <Flex
          sx={{
            flexDirection: 'column',
            gap: theme.spacing.medium,
            [theme.breakpoints.down('medium')]: {
              padding: theme.spacing.medium,
              width: '100vw',
              bottom: theme.spacing.small,
              position: 'fixed',
              background: theme.colors.white,
              margin: '-16px',
            },
          }}
        >
          <Button isFullWidth isPseudo variant="primary">
            {/* eslint-disable-next-line styled-components-a11y/anchor-is-valid */}
            <SimpleBlockLink
              className="intercom-workflow-broadband-cancel"
              href="#"
              onClick={event => {
                event.preventDefault()
                handleChatRequest()
              }}
            >
              Continue to cancel order
            </SimpleBlockLink>
          </Button>
          <Button isFullWidth variant="link" onClick={() => setShowModal(false)}>
            Close modal
          </Button>
        </Flex>
      </Modal>
    </Card>
  )
}

// TODO: this is a temporary workaround for the Button component lacking a className prop
// Remove once updated/we have a better solution
const SimpleBlockLink = styled.a`
  display: block;
`

export default OrderDetailsCard
